"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PenToolManager = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
class PenToolManager {
    constructor(toolsState, toolsOptions, bridge) {
        this.canvas = null;
        this.canvasForScreenshot = null;
        this.toolsState = toolsState;
        this.toolsOptions = toolsOptions;
        this.bridge = bridge;
    }
    updatePenOptions(options) {
        var _a, _b, _c, _d, _e, _f;
        const state = (_a = this.toolsOptions.getState()) !== null && _a !== void 0 ? _a : {};
        const newOptions = Object.assign(Object.assign({}, state.penOptions), options);
        this.toolsOptions.dispatch({
            type: 'toolsOptions/BridgeObjectChanged',
            payload: {
                identifier: 'toolsOptions',
                keyPath: 'penOptions',
                changes: newOptions,
            },
        });
        if (options.color) {
            this.bridge.toolUpdatePen({ color: options.color });
        }
        if (options.opacity !== undefined) {
            this.bridge.toolUpdatePen({ opacity: options.opacity });
        }
        if (options.size !== undefined) {
            this.bridge.toolUpdatePen({ size: options.size });
        }
        this.bridge.toolkitOptionsAction({
            optionType: newOptions.optionType,
            color: (_c = (_b = newOptions.color) === null || _b === void 0 ? void 0 : _b.split(',').map(Number)) !== null && _c !== void 0 ? _c : [229, 51, 157],
            type: (_d = newOptions.type) !== null && _d !== void 0 ? _d : bridge_schema_1.ToolType.Pen2D,
            val: (_e = (1 - newOptions.opacity) * 100) !== null && _e !== void 0 ? _e : 0,
            size: (_f = 4 - newOptions.size) !== null && _f !== void 0 ? _f : 3,
        });
    }
    update2DPenState(curves) {
        this.toolsState.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'pen2DState.curves',
                changes: curves,
            },
        });
    }
    get2DPenState() {
        const screenWidth = document.body.offsetWidth;
        const screenHeight = document.body.offsetHeight;
        const screenRatio = screenWidth / screenHeight;
        const state = this.toolsState.getState();
        if (!(state === null || state === void 0 ? void 0 : state.pen2DState)) {
            return {
                curvesInfoArray: [],
                screenRatio,
            };
        }
        const { curves = [] } = state === null || state === void 0 ? void 0 : state.pen2DState;
        return {
            curvesInfoArray: curves.map(curve => {
                const { size, points, color } = curve;
                return {
                    size,
                    points2D: points.map(point => `{${point.x}, ${point.y}}`),
                    color,
                };
            }),
            screenRatio,
        };
    }
    set2DPenState(state) {
        if (!state.curvesInfoArray) {
            this.toolsState.dispatch({
                type: 'toolsState/BridgeObjectChanged',
                payload: {
                    identifier: 'toolsState',
                    keyPath: 'pen2DState.curves',
                    changes: [],
                },
            });
            return;
        }
        const curves = state.curvesInfoArray.map((curve) => {
            return {
                size: curve.size,
                points: curve.points2D.map((point) => {
                    const [x, y] = point.slice(1, -1).split(', ');
                    return {
                        x: Number(x),
                        y: Number(y),
                    };
                }),
                color: curve.color,
            };
        });
        this.toolsState.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'pen2DState.curves',
                changes: curves,
            },
        });
    }
    setCanvas(context) {
        this.canvas = context;
    }
    setCanvasForScreenshot(context) {
        this.canvasForScreenshot = context;
    }
    getCanvasForScreenshot() {
        return this.canvasForScreenshot;
    }
    screenshot() {
        var _a;
        return (_a = this.canvasForScreenshot) === null || _a === void 0 ? void 0 : _a.toDataURL();
    }
    updateUndoRedoHistory() {
        var _a;
        (_a = this.bridge) === null || _a === void 0 ? void 0 : _a.addActionToHistory({
            state: {
                paintManagerState: {
                    drawer2DCurrentState: this.get2DPenState(),
                },
            },
        });
    }
}
exports.PenToolManager = PenToolManager;
